import { ConditionRegistryItem } from '../../ConditionRegistryItem';
import { ConditionRegistryCategory } from '../../ConditionRegistryCategory';
export class ConditionRegistryStage extends ConditionRegistryCategory {
    label = 'Stage';
    constructor(parent) {
        super(parent);
        super.init();
    }
    isDraftStage = () => new ConditionRegistryItem({
        eval: ({ app }) => app.stage.stageTypeInfo.isDraftStage,
    });
    isAbfragerStage = () => new ConditionRegistryItem({
        eval: ({ app }) => app.stage.stageTypeInfo.isAbfragerStage,
    });
    isDraftRunStage = () => new ConditionRegistryItem({
        eval: ({ app }) => app.stage.stageTypeInfo.isDraftRunStage,
    });
    isAbfragerRunStage = () => new ConditionRegistryItem({
        eval: ({ app }) => app.stage.stageTypeInfo.isAbfragerRunStage,
    });
    isStageFoggy = () => new ConditionRegistryItem({
        eval: ({ app }) => app.stage.isStageFoggy,
    });
}
